import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20composition%20with%20designer%20sunglasses%20gold%20jewelry%20silk%20scarves%20and%20small%20decorative%20objects%20on%20soft%20cream%20marble%20surface%20warm%20natural%20side%20light%20editorial%20photography%20minimalist%20arrangement%20sophisticated%20aesthetic%20gentle%20shadows&width=1600&height=600&seq=cta-bg-v3-new&orientation=landscape"
          alt="Hipobuy Spreadsheet - Commencez maintenant"
          title="Hipobuy Spreadsheet - Plateforme de gestion de données"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/25"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          {/* Left - Title */}
          <div className="lg:w-[60%]">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              hipobuy spreadsheet
            </h2>
            <p className="mt-4 text-base md:text-lg text-background-50/80 max-w-[500px] leading-relaxed">
              Rejoignez la nouvelle génération de professionnels de l&apos;e-commerce.
              Accès immédiat, sans engagement.
            </p>
          </div>

          {/* Right - Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="btn-cta inline-flex items-center gap-3 bg-background-50 hover:bg-background-100 text-foreground-900 px-8 py-4 rounded-full text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              hipobuy spreadsheet
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="btn-cta inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-4 rounded-full text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-cart-line"></i>
              </span>
            </a>
          </div>
        </div>

        {/* Bottom links */}
        <div className="mt-14 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row gap-6">
          <Link
            to="/article/hipobuy-spreadsheet-guide-complet"
            className="inline-flex items-center gap-2 text-sm text-background-50/75 hover:text-background-50 transition-colors group"
          >
            Lire notre guide complet sur Hipobuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <Link
            to="/guide-achat"
            className="inline-flex items-center gap-2 text-sm text-background-50/75 hover:text-background-50 transition-colors group"
          >
            Consulter le guide d&apos;achat
            <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}